import { NAME } from './constants';

export const ADD_GUARANTOR_OF_REGION = `${NAME}/ADD_GUARANTOR_OF_REGION`;
export const ADD_GUARANTORS = `${NAME}/ADD_GUARANTORS`;
export const APPEND_GUARANTORS = `${NAME}/APPEND_GUARANTORS`;
export const ENABLE_SAVE = `${NAME}/ENABLE_SAVE`;
export const REMOVE_GUARANTOR_OF_REGION = `${NAME}/REMOVE_GUARANTOR_OF_REGION`;
export const RESET = `${NAME}/RESET`;
export const RESET_GUARANTORS = `${NAME}/RESET_GUARANTORS`;
export const SELECT_GUARANTORS = `${NAME}/SELECT_GUARANTORS`;
export const SET_GUARANTORS = `${NAME}/SET_GUARANTORS`;
export const SET_GUARANTORS_OF_REGION = `${NAME}/SET_GUARANTORS_OF_REGION`;
export const SET_RADIO_BUTTON = `${NAME}/SET_RADIO_BUTTON`;
export const GUARANTORS_EDIT_HARD_RESET = `${NAME}/GUARANTORS_EDIT_HARD_RESET`;
